import { PlanStatusActive } from "@/common/enums/enums";
import clsx from "clsx";

interface PlanStatusBadgeProps {
  status: PlanStatusActive;
}

export default function PlanStatusBadge(
  props: PlanStatusBadgeProps
): JSX.Element {
  const statusStyle = {
    [PlanStatusActive.ACTIVE]: "text-white bg-success",
    [PlanStatusActive.CANCELLED]: "text-white bg-error",
  };

  return (
    <span
      className={clsx(
        "text-xs px-3 py-1 rounded-full border font-medium",
        statusStyle[props.status]
      )}
    >
      {props.status}
    </span>
  );
}
